interface CanonicalTagProps {
  path: string;
  baseUrl?: string;
}

const DEFAULT_BASE = import.meta.env.VITE_SITE_URL || '';

/**
 * Renders a <link rel="canonical"> tag.
 * React 19 automatically hoists this into <head>.
 * Also renders og:url for consistent social sharing.
 */
export default function CanonicalTag({ path, baseUrl = DEFAULT_BASE }: CanonicalTagProps) {
  const canonical = `${baseUrl}${path}`;
  return (
    <>
      <link rel="canonical" href={canonical} />
      <meta property="og:url" content={canonical} />
    </>
  );
}
